<template lang="pug">
#gallery
  
  //- #page(:class="{ loading: loading }") {{ page }}
  
  .gallery-wrapper(infinite-wrapper)
    post-tile(v-for="(item, index) in items" :key="index" :item="item" :size.sync="size")
    .clearfix
  infinite-loading(:identifier="infiniteId" @infinite="infiniteHandler" spinner="waveDots" force-use-infinite-wrapper :distance="200" no-results="Nothing found...")
    div(slot="no-more")
</template>
<script>
import { mapGetters } from "vuex";
import _ from "lodash";

import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";

// Components
import PostTile from "@/components/PostTile";

const CancelToken = axios.CancelToken;
var cancel;

export default {
  name: "Gallery",
  components: {
    InfiniteLoading,
    PostTile
  },
  props: {
    type: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: false
    },
    sort: {
      type: String,
      required: false,
      default: "POPULAR"
    },
    size: {
      type: String,
      required: false,
      default: "small"
    }
  },
  mounted() {
    if (document.body.classList == "isNativeApp") {
      this.$emit("update:size", "mediun");
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      page: -1,
      count: 15,
      infiniteId: new Date()
    };
  },
  computed: {
    ...mapGetters(["category"]),
    filteredItems() {
      let items = this.items;
      if (["explore", "feed"].indexOf(this.type) !== -1) {
        items = items.filter(item => {
          return (
            this.category === "everything" || item.category === this.category
          );
        });
      }
      return _.chain(items)
        .uniqBy("_id")
        .sortBy("like_count")
        .reverse()
        .values();
    }
  },
  watch: {
    category(to, from) {
      if (to !== from) {
        this.resetGallery();
      }
    },
    sort(to, from) {
      if (to !== from) {
        this.resetGallery();
      }
    },
    size(to, from) {
      if (to !== from) {
        this.resetGallery();
      }
    }
  },
  methods: {
    resetGallery() {
      cancel();
      this.$nextTick(() => {
        this.items = [];
        this.page = -1;
        this.infiniteId = new Date();
      });
    },
    loadPhotos($state, photos) {
      if (photos.length) {
        this.items.push(...photos);

        if ($state) {
          $state.loaded();
        }
      } else {
        if ($state) {
          $state.complete();
        }
      }
      this.loading = false;
    },
    feedRequest($state) {
      axios
        .get(`${process.env.VUE_APP_API_URL}/photos/feed`, {
          params: {
            page: this.page,
            category: this.category,
            sort: this.sort,
            count: this.count
          },
          cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            cancel = c;
          })
        })
        .then(response => {
          this.loadPhotos($state, response.data.photos);
        })
        .catch(function(thrown) {
          if (axios.isCancel(thrown)) {
            console.log("Request canceled", thrown.message);
          } else {
            // handle error
            console.log(thrown);
          }
        });
    },
    profileRequest($state) {
      axios
        .get(`${process.env.VUE_APP_API_URL}/users/${this.id}/photos`, {
          params: {
            page: this.page,
            count: this.count
          }
        })
        .then(response => {
          this.loadPhotos($state, response.data.photos);
        })
        .catch(function(thrown) {
          if (axios.isCancel(thrown)) {
            console.log("Request canceled", thrown.message);
          } else {
            // handle error
            console.log(thrown);
          }
        });
    },
    infiniteHandler($state) {
      this.page += 1;
      this.loading = true;

      switch (this.type) {
        case "profile":
          this.profileRequest($state);
          break;

        default:
          // feed, explore
          this.feedRequest($state);
          break;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
#gallery {
  // margin: -2px;
  overflow: hidden;

  #page {
    border-radius();
    pinned-tr(fixed);
    background-color: $color-success;
    color: white;
    line-height: 30px;
    padding: 0 15px;
    z-index: 99999;

    &.loading {
      background-color: $color-danger;
    }
  }
}
</style>